'use strict';

angular.module('theme').component('discountCodeBanner', {
	bindings: {
		code: '<'
	},
	templateUrl: 'component/discount-code-banner.html',
	controller: function($scope, $cookies) {
		var self = this;
		self.showBanner = false;

		if ($cookies.get('campaign-code-discount') && self.code && typeof self.code === 'string' && self.code !== '') {
			var data = JSON.parse($cookies.get('campaign-code-discount'));

			if (self.code !== data.code) return;

			self.description = decodeURIComponent(data.description);
			self.amount = data.amount;

			$cookies.put('campaign-code', self.code, {
				path: '/',
				expires: moment().add(1, 'month').toDate()
			});

			self.showBanner = true;
		}
	}
});